export enum DistributionTypeEnum{
    Standard = 1,
    Residual = 2
}

export enum DistributionStatusEnum {
    Drafted = 1,
    ReadyForProcessing = 2,
    PendingPayment = 3,
    CompletedPublished = 4
}